const TERMS_AND_CONDITIONS = 'https://anthe.aakash.ac.in/anthe/terms-conditions'
const AKTHE_TERMS_AND_CONDITIONS = 'https://uat-akthe.aakash.ac.in/akthe/terms-condition'
const PRIVACY_POLICY = 'https://www.aakash.ac.in/privacypolicy'

export { TERMS_AND_CONDITIONS, PRIVACY_POLICY, AKTHE_TERMS_AND_CONDITIONS }
